export const TASK_EVENTS = {
  ASSIGNED: 'assigned',
  COMPLETED: 'completed',
} as const;

export const TASK_EVENT_PREFIX = 'task' as const;
